export enum UserTypeEnum {
    SUPER = 'SUPER',
    ADMIN = 'ADMIN',
    MEMBER = 'MEMBER'
}
